import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import { RutaBase } from "./Utils/Funciones";
import { nombreDeRol } from "./constantes/nombreDeRol";

//Pages
import autenticacion from "./paginas/autenticacion/autenticacion";
import ConsultaPadron from "./paginas/Padron/ConsultaPadron/ConsultaPadron";
import Error from "./paginas/Error/Error";
import Inicio from "./paginas/Inicio/Inicio";
import AccesoDenegado from "./paginas/Error/AccesoDenegado";
import AccesoDenegadoSistema from "./paginas/Error/AccesoDenegadoSistema";
import NoAutorizado from "./paginas/Error/NoAutorizado";
import PaginaNoEncontrada from "./paginas/Error/PaginaNoEncontrada";
import SesionDesconectada from "./paginas/SesionDesconectada/SesionDesconectada";
import ProtectedRoute from "./componentes/Comunes/ProtectedRoute/ProtectedRoute";
import ConsultaSolicitudesPadron from "./paginas/Padron/ConsultaSolicitudesPadron/ConsultaSolicitudesPadron";
import DetalleSolicitudPadron from "./paginas/Padron/DetalleSolicitudPadron/DetalleSolicitudPadron";
import InclusionSolicitud from "./paginas/Padron/InclusionSolicitud/InclusionSolicitud";
import { ModificacionSolicitud } from "./paginas/Padron/ModificacionSolicitud/ModificacionSolicitud";
import PerfilUsuario from "./paginas/Usuario/PerfilUsuario";
import { ReporteCrediticio } from "./paginas/ReporteCrediticio/ReporteCrediticio";
import { ArchivoDescargable } from "./paginas/ArchivoDescargable/ArchivoDescargable";
import ConsultaAutorizacion from "./paginas/Autorizaciones/ConsultasAutorizacion/ConsultaAutorizacion";
import ConsultaRevocaciones from "./paginas/Autorizaciones/ConsultaRevocaciones/ConsultaRevocaciones";
import IncluirAutorizacion from "./paginas/Autorizaciones/IncluirAutorizacion/IncluirAutorizacion";
import Formularios from "./paginas/Autorizaciones/Formularios/Formularios";
import ConsultaEliminadas from "./paginas/Autorizaciones/ConsultaEliminadas/ConsultaEliminadas";
import SolicitarModificacion from "./paginas/CambiosCic/SolicitarModificacion/SolicitarModificacion";
import SolicitudesDeCambio from "./paginas/CambiosCic/SolicitudesDeCambio/SolicitudesDeCambio";
import servicioUsuario from "./servicios/servicioUsuario";
import SolicitudPasaporte from "./paginas/Padron/SolicitudPadronPasaporte/SolicitudPadronPasaporte";

const Routes = () => {
  return (
    <BrowserRouter forceRefresh basename="/cic_externo">
      <Switch>
        <ProtectedRoute exact path={RutaBase(true) + "/"} component={Inicio} />
        <ProtectedRoute
          exact
          path={RutaBase(true) + "/Inicio/"}
          component={Inicio}
        />
        <Route
          exact
          path={RutaBase(true) + "/autenticacion"}
          component={autenticacion}
        />
        <ProtectedRoute
          exact
          path={RutaBase(true) + "/Padron/ConsultaPadron/"}
          component={ConsultaPadron}
          tieneAccesoPermitido={servicioUsuario.tieneRol(
            nombreDeRol.PadronConsultar
          )}
        />
        <ProtectedRoute
          exact
          path={RutaBase(true) + "/Padron/ConsultaSolicitudesPadron/"}
          children={(props) => <ConsultaSolicitudesPadron {...props} />}
          tieneAccesoPermitido={servicioUsuario.tieneRol(
            nombreDeRol.PadronConsultarSolicitudes
          )}
        />
        <ProtectedRoute
          exact
          path={RutaBase(true) + "/Padron/DetalleSolicitudPadron/"}
          children={(props) => <DetalleSolicitudPadron {...props} />}
          tieneAccesoPermitido={servicioUsuario.tieneRol(
            nombreDeRol.PadronConsultarSolicitudes
          )}
        />
        <ProtectedRoute
          exact
          path={RutaBase(true) + "/Padron/InclusionSolicitud/"}
          children={(props) => <InclusionSolicitud />}
          tieneAccesoPermitido={servicioUsuario.tieneRol(
            nombreDeRol.PadronTramitarSolicitudes
          )}
        />
        <ProtectedRoute
          exact
          path={RutaBase(true) + "/Padron/ModificacionSolicitud/"}
          children={(props) => <ModificacionSolicitud />}
          tieneAccesoPermitido={servicioUsuario.tieneRol(
            nombreDeRol.PadronTramitarSolicitudes
          )}
        />
        <ProtectedRoute
          exact
          path={RutaBase(true) + "/Padron/SolicitudPasaporte/"}
          children={(props) => <SolicitudPasaporte />}
          tieneAccesoPermitido={servicioUsuario.tieneRol(
            nombreDeRol.PadronTramitarSolicitudes
          )}
        />
        <ProtectedRoute
          exact
          path={RutaBase(true) + "/Usuario/Perfil/"}
          component={PerfilUsuario}
        />
        <Route exact path={RutaBase(true) + "/Error/"} component={Error} />
        <Route
          exact
          path={RutaBase(true) + "/Error/AccesoDenegado/"}
          component={AccesoDenegado}
        />
        <Route
          exact
          path={RutaBase(true) + "/Error/AccesoDenegadoSistema/"}
          component={AccesoDenegadoSistema}
        />
        <Route
          exact
          path={RutaBase(true) + "/Error/NoAutorizado/"}
          component={NoAutorizado}
        />
        <Route
          exact
          path={RutaBase(true) + "/SesionDesconectada/"}
          component={SesionDesconectada}
        />
        <ProtectedRoute
          exact
          path={RutaBase(true) + "/InformacionCrediticia/GenerarReporte"}
          component={ReporteCrediticio}
          tieneAccesoPermitido={servicioUsuario.tieneRol(
            nombreDeRol.InformacionCrediticiaConsultaReporte
          )}
        />
        <ProtectedRoute
          exact
          path={RutaBase(true) + "/InformacionCrediticia/ArchivoDescargable"}
          component={ArchivoDescargable}
          tieneAccesoPermitido={servicioUsuario.tieneRol(
            nombreDeRol.InformacionCrediticiaDescargaArchivos
          )}
        />
        <ProtectedRoute
          exact
          path={RutaBase(true) + "/Autorizacion/ConsultaAutorizaciones"}
          component={ConsultaAutorizacion}
          tieneAccesoPermitido={servicioUsuario.tieneRol(
            nombreDeRol.AutorizacionConsultar
          )}
        />
        <ProtectedRoute
          exact
          path={RutaBase(true) + "/Autorizacion/ConsultaRevocaciones"}
          component={ConsultaRevocaciones}
          tieneAccesoPermitido={servicioUsuario.tieneRol(
            nombreDeRol.AutorizacionConsultar
          )}
        />
        <ProtectedRoute
          exact
          path={RutaBase(true) + "/Autorizacion/IncluirAutorizacion"}
          component={IncluirAutorizacion}
          tieneAccesoPermitido={servicioUsuario.tieneRol(
            nombreDeRol.AutorizacionTramitar
          )}
        />
        <ProtectedRoute
          exact
          path={RutaBase(true) + "/Autorizacion/ConsultaEliminadas"}
          component={ConsultaEliminadas}
          tieneAccesoPermitido={servicioUsuario.tieneRol(
            nombreDeRol.AutorizacionConsultar
          )}
        />
        <ProtectedRoute
          exact
          path={RutaBase(true) + "/Autorizacion/Formularios"}
          component={Formularios}
        />
        <ProtectedRoute
          exact
          path={RutaBase(true) + "/CambiosCIC/SolicitarModificacion"}
          component={SolicitarModificacion}
          tieneAccesoPermitido={servicioUsuario.tieneRol(
            nombreDeRol.CambiosCicSolicitar
          )}
        />
        <ProtectedRoute
          exact
          path={RutaBase(true) + "/CambiosCIC/SolicitudesDeCambio"}
          component={SolicitudesDeCambio}
          tieneAccesoPermitido={
            servicioUsuario.tieneRol(nombreDeRol.CambiosCicAprobar) ||
            servicioUsuario.tieneRol(nombreDeRol.CambiosCicSolicitar)
          }
        />
        <Route component={PaginaNoEncontrada} />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
